import {dsColorNew} from "@palette";

export const appConfig = {
    favicon: "/favicon.svg",
    logo: "/images/dipi_ico.png",
    emptyImage: '/images/empty_content.svg',
    appName: "SKU Mapper",
    logoutURL: '/logout',
    header: {
        height: 72,
        showCircle: false,
        showNotifications: false,
        showLang: false,
        showChat: false
    },
    menu: {
        size: 'extended',
        showAppIcon: true,
        spacing: 0,
        nav: {
            width: {
                mini: 100
            }
        }
    }
}

export const styles = {
    main: {
        pl: 5,
        pr: 5,
        // Header is 72px tall (fixed). Add ~16px so floating field labels
        // (e.g. a shrunk "Date" label) aren't clipped under the header.
        pt: '88px',
        pb: '32px',
        backgroundColor: dsColorNew.contentBg,
    },
    header: {
        backgroundColor: '#ffffff',
        color: '#111827',
        borderBottom: `1px solid ${dsColorNew.grayBorder}`,
        boxShadow: 'none',
    }
}